import axios from "axios";
import { useEffect } from "react";

export default function Login() {

  useEffect(() => {
    document.title = "Login - SparePart";
    
  }, []);

  function handleLogin(e) {
    e.preventDefault();
    const username = e.target.form.username.value;
    console.log("Logging in user:", username);

    axios.get(`${process.env.REACT_APP_API_URL}/authenticate`, {
      params: { username: username.toLowerCase() }
    }
    ).then(response => {

      
      if(response.data.message === "User already logged in"){
        alert("User already logged in.");
        document.getElementById("login-form").reset();
        return;
      }
      console.log("Authentication response:", response.data);
      window.localStorage.setItem("token", response.data.token);
      window.location.href = '/dashboard';
     
    }).catch(error => {
      document.getElementById("login-form").reset();
      alert(error.message || "Login failed. Please try again.");
    });
  }
  return (
    <div className="App">
      <header className="App-header">
        <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" className="logo" alt="logo" />

        <p>
          Login Page
        </p>

      </header>
      <main>
        <form id="login-form">
          <input type="text" placeholder="Username" name='username' />
          <button onClick={handleLogin}>Login</button>
        </form>
      </main>
    </div>
  );
}